import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridRow, GridColumn } from "arv-reactcomponents";
import ProductActions from "../ProductActions";
import { Checkout } from "npmlinks-constants";

class OosView extends Component {
  get oosMessage() {
    return !this.props.instock
      ? Checkout.CHECKOUT_MESSAGES.PRODUCT.OOS
      : Checkout.CHECKOUT_MESSAGES.PRODUCT.NOT_SERVICEABLE;
  }
  render() {
    const { product } = this.props;
    return (
      <GridColumn className="nw-cartproductview-oos-container nwc-translucentbackground-white">
        <GridRow>
          <GridColumn className="nwc-grid-col-xs-4" />
          <GridColumn className="nwc-grid-col-xs-8">
            <div className="nw-cartproductview-oos">
              <div className="nw-cartproductview-oostext">
                <strong>{this.oosMessage.TITLE}</strong>
                {this.oosMessage.MESSAGE}
              </div>
              <ProductActions.component
                product={product}
                className="nw-cartproductview-oos"
              />
            </div>
          </GridColumn>
        </GridRow>
      </GridColumn>
    );
  }
}

OosView.propTypes = {
  product: PropTypes.shape({}).isRequired,
  instock: PropTypes.bool.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OosView,
  component: OosView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/OosView/index.js